import { enUS, ptBR, type Locale } from 'date-fns/locale';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const localeMap: Record<string, Locale> = {
  en: enUS,
  'en-US': enUS,
  pt: ptBR,
  'pt-BR': ptBR,
};

const uses24HourFormat = (language: string) =>
  ['pt', 'pt-BR'].includes(language) || language?.startsWith('pt');

export const useDateLocale = () => {
  const { i18n } = useTranslation();
  return useMemo(() => {
    const lang = i18n.language;
    const locale = localeMap[lang] ?? localeMap[lang?.split('-')[0]] ?? enUS;
    const timeFormat = uses24HourFormat(lang ?? '') ? 'HH:mm' : 'h:mm a';
    return { locale, timeFormat };
  }, [i18n.language]);
};
